'use strict';

import React from 'react';

/**
 * @extends {React.Component}
 */
class ModalButtons extends React.Component {

  /**
   * @return {JSX} JSX component markup.
   */
  render () {
    const { children } = this.props;
    return (
      <div className="Modal-buttonGroup ButtonGroup">
        { children }
      </div>
    );
  }
}

/**
 * @prop {propTypes} propTypes attributes for the Modal component
 */
ModalButtons.propTypes = {};

ModalButtons.defaultProps = {};

export default ModalButtons;



// WEBPACK FOOTER //
// ./src/components/clarity-ui/components/modal/modalButtons.jsx